import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useUnmount } from '../../hooks/use-unmount';
import { selectModalStack } from '../../redux/selectors';
import { modalPush, modalRemove } from '../../redux/modal/actions.modal';
import { pipe } from '../../util';

const CLOSED = 0;
const CLOSING = 1;
const OPEN = 2;

export const useModal = ({ onFadeOut, visible }) => {
  const modalStack = useSelector(selectModalStack);
  const dispatch = useDispatch();
  const [id] = useState(Symbol(''));

  const addModal = pipe(modalPush, dispatch);
  const removeModal = pipe(modalRemove, dispatch);

  const shouldRender = modalStack.last() === id;
  const isInStack = modalStack.includes(id);

  const [state, setState] = useState(visible ? OPEN : CLOSED);
  function close() {
    setState(CLOSING);
  }
  function push() {
    setState(OPEN);
    addModal(id);
  }
  const pop = () => removeModal(id);
  function onBackdropFade() {
    setState(CLOSED);
    pop();
    if (onFadeOut) onFadeOut();
  }
  function effect() {
    if (visible && !isInStack) push();
    if (!visible && shouldRender) close();
  }
  useEffect(effect, [shouldRender, visible]);
  useUnmount(pop);
  return { backdropIsVisible: state === OPEN, onBackdropFade, shouldRender };
};
